<template>
  <el-upload
    action="#"
    list-type="picture-card"
    :http-request="imgUpload"
    :on-remove="handleRemove"
    :file-list="fileList"
    :limit="limit"
  >
    <i class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
import { number } from "echarts";
export default {
  props: {
    limit: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      fileList: [],
      urlList: [],
    };
  },
  methods: {
    imgUpload(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$config.fileUpload(formData).then((res) => {
        if (res.data.code === 200) {
          this.fileList.push({
            name: file.file.name,
            url: this.$config.imgUrl + res.data.data,
            uid: file.file.uid,
          });
          this.urlList.push({
            name: file.file.name,
            url: res.data.data,
            uid: file.file.uid,
          });
          this.$emit("getUploadFile", this.urlList);
        }
      });
    },
    handleRemove(file, fileList) {
      let i = this.fileList.find((e) => {
        return e.uid === file.uid;
      });
      this.fileList.splice(i, 1);
      this.urlList.splice(i, 1);
      this.$emit("getUploadFile", this.urlList);
    },
  },
};
</script>

<style lang="less" scoped></style>
